
<template>
  <v-form v-model="form_valido" ref="form" lazy-validation>
    <z-dialogo ref="dialogo" titulo="Conta a Pagar" :dividers="true" largura="700px" persistent @fechar="onFechar">
      <template #conteudo>
        <v-row dense>

          <v-col cols="12" sm="4">
            <z-campo-valor
              label="Valor Total"
              v-model="contapagar.valor"
              filled
              dense
              readonly
            ></z-campo-valor>
          </v-col>

          <v-col cols="12" sm="3">
            <z-text-field
              v-model="contapagar.parcelas"
              label="Parcelas"
              type="number"
              min="1"
              step="1"
              dense
              persistent-hint
              :hint="parcelado"
              @input="onChangeParcelas"
            ></z-text-field>
          </v-col>

          <v-col col="12" sm="5">
            <v-select
              v-model="contapagar.forma_pagamento"
              label="Forma de Pagamento"
              :items="$globals.FORMAS_DE_PAGAMENTO"
              filled
              dense
            ></v-select>
          </v-col>

        </v-row>
      </template>
      
      <template #actions_right>
        <v-btn text @click="$refs.dialogo.fechar()" :disabled="salvando">
          Cancelar
        </v-btn>
        <v-btn depressed color="primary" @click="lancar" :disabled="!form_valido" :loading="salvando">
          Lançar Conta a Pagar
        </v-btn>
      </template>
    </z-dialogo>


  </v-form>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, inject } from 'vue';
import { hoje } from '@/app/helpers/utils';
import { valorBR } from '@/app/helpers/formatacoes';
import queryBuilder from '@/app/helpers/QueryBuilder';

const emits = defineEmits(['onGerarParcelas']);
const props = defineProps({
  saldo: {
    type: [Number, String],
    required: true,
  },
});

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $globals = proxy.$globals;
const $notificacao = inject('notificacao');

const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const salvando = ref(false);

const movimento = computed(() => {
  return $store.state.movimentoestoque.movimento;
});

const contapagar = ref({
  vencimento: hoje(),
  forma_pagamento: "Depósito Bancário",
  valor: 0,
  parcelas: 1,
  valor_parcela: 0,
});

const parcelado = computed(() => {
  if (contapagar.value.valor === 0 || contapagar.value.parcelas < 1) {
    return "";
  }

  if (contapagar.value.dividir_parcelar === "Repetir") {
    return `${contapagar.value.parcelas}x de R$ ${valorBR(contapagar.value.valor)}` ;
  } else {
    return `${contapagar.value.parcelas}x de R$ ${valorBR(contapagar.value.valor / contapagar.value.parcelas)}`;
  }
});

function resetarDados(saldo) {
  contapagar.value = {
    vencimento: hoje(),
    forma_pagamento: "Depósito Bancário",
    valor: movimento.value.valor_total,
    parcelas: 1,
    valor_parcela: saldo,
  };

  // contapagar.value.valor = movimento.value.valor_total;
  // contapagar.value.valor_parcela = movimento.value.valor_total;
}

onMounted(async () => {




  // await $store.dispatch("listas/fetchListas", [
  //     queryBuilder()
  //       .from("Banco")
  //       .selectraw("id as value, concat(codigo, ' - ', descricao) as text")
  //       .orderBy("codigo")
  //       .build()
  // ]);
});

function abrir() {
  resetarDados(props.saldo);
  dialogo.value.abrir();
}

function fechar() {
  onFechar();
  dialogo.value.fechar();
}

function onFechar() {
  form.value.resetValidation();
}

async function lancar() {

  salvando.value = true;
  // console.log("SALVAR CHAVEPIX", chavePix.value);
  try {
    emits('onGerarParcelas', contapagar.value);
    // $notificacao.notificar("Chave Pix salva com sucesso!");
  } catch (error) {
    $notificacao.error("Houve um erro ao salvar a Chave Pix", error);
    throw error;
  } finally {
    salvando.value = false;
    dialogo.value.fechar();
  }
}

function onChangeParcelas() {
  if (contapagar.value.parcelas > 1) {
    contapagar.value.valor_parcela = (props.saldo / contapagar.value.parcelas);
  } else {
    contapagar.value.valor_parcela = props.saldo;
  }
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>